module.exports = __webpack_public_path__ + "static/media/1717128338673-min.394916c0.JPG";